<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.addProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Provider Name Input -->
          <base-select-input
            col="6"
            :optionsList="providers"
            :placeholder="$t('SIDENAV.providers.name')"
            v-model="data.provider_name"
            required
          />
          <!-- End:: Provider Name Input -->

          <!-- Start:: Additions Input -->
          <base-select-input
            col="6"
            :optionsList="additions"
            :placeholder="$t('PLACEHOLDERS.additions')"
            v-model="data.additions"
            multiple
          />
          <!-- End:: Additions Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codename')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codenameEn')"
            v-model.trim="data.nameEn"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Description Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProd')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProdEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <!-- End:: Description Input -->

          <!-- Start:: Category Input -->
          <base-select-input
            col="12"
            :optionsList="categories"
            :placeholder="$t('PLACEHOLDERS.category')"
            v-model="data.category"
            required
          />
          <!-- End:: Category Input -->

          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.productImg')"
            @selectImage="selectImage"
            required
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Image Upload Input -->
          <base-multi-image-upload-input
            :urls="imgUrls"
            multiple
            @onFileSelect="onFileSelect"
            @onFileRemove="onFileRemove"
          >
            {{ $t("PLACEHOLDERS.productImgs") }}
          </base-multi-image-upload-input>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Sizes and Prices Input -->
          <div class="col-12">
            <div
              v-for="(size, index) in data.sizes"
              :key="index"
              class="row align-items-center mb-2"
            >
              <base-select-input
                col="5"
                :optionsList="availableSizes"
                :placeholder="$t('PLACEHOLDERS.size')"
                v-model="size.size"
                required
              />
              <base-input
                col="5"
                type="number"
                :step="0.01"
                :placeholder="$t('PLACEHOLDERS.price')"
                v-model="size.price"
                required
              />
              <div class="col-2">
                <v-btn
                  v-if="data.sizes.length > 1"
                  @click="removeSizeRow(index)"
                  class="remove_size_row"
                >
                  <i class="fas fa-minus"></i>
                </v-btn>
                <v-btn
                  v-if="
                    index === data.sizes.length - 1 &&
                    data.sizes.length < sizes.length
                  "
                  @click="addSizeRow"
                  class="mx-2 add_size_row"
                >
                  <i class="fas fa-plus"></i>
                </v-btn>
              </div>
            </div>
          </div>
          <!-- End:: Sizes and Prices Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "CreateProduct",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",
      additionalFiles: [],
      additionalImages: [],
      imgUrls: [],

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        provider_name: null,
        category: null,
        sizes: [{ size: null, price: null }],
        additions: [],
        active: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
      },
      // End:: Data Collection To Send
      providers: [],
      categories: [],
      sizes: [],
      additions: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    mostPaids() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: true,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: false,
        },
      ];
    },
    availableSizes() {
      const selectedSizes = this.data.sizes.map((size) => size.size);
      return this.sizes.filter((size) => !selectedSizes.includes(size));
    },
  },

  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.data.imgUrls, index);
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    selectAdditionalImages(selectedImages) {
      this.additionalFiles = selectedImages;
    },

    addSizeRow() {
      if (this.data.sizes.length < this.sizes.length) {
        this.data.sizes.push({ size: null, price: null });
      }
    },

    removeSizeRow(index) {
      this.data.sizes.splice(index, 1);
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.name = this.data.name.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.name) {
        REQUEST_DATA.append("name[ar]", this.data.name);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.descProd) {
        REQUEST_DATA.append("description[ar]", this.data.descProd);
      }
      if (this.data.descProdEn) {
        REQUEST_DATA.append("description[en]", this.data.descProdEn);
      }
      if (this.data.provider_name) {
        REQUEST_DATA.append("user_id", this.data.provider_name.id);
      }
      if (this.data.category) {
        REQUEST_DATA.append("category_id", this.data.category.id);
      }
      if (this.data.sizes.length && this.data.sizes[0].price != null) {
        REQUEST_DATA.append(
          "sizes",
          JSON.stringify(
            this.data.sizes?.map((size) => ({
              size_id: size.size?.id,
              price: size?.price,
            }))
          )
        );
      }
      if (this.data.additions.length) {
        this.data.additions.forEach((addition) => {
          REQUEST_DATA.append("addition_ids[]", addition.id);
        });
      }
      if (this.data.image.file) {
        REQUEST_DATA.append("file_path", this.data.image.file);
      }
      if (this.additionalImages.length) {
        this.additionalImages.forEach((file) => {
          REQUEST_DATA.append("files_paths[]", file);
        });
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `products`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/products/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
    async fetchProviders() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "providers?page=0&limit=0&is_active=1",
          params: {
            is_allowed: 1,
          },
        });
        this.providers = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async fetchCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "categories?page=0&limit=0&is_active=1",
          params: {
            is_allowed: 1,
          },
        });
        this.categories = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async fetchSizes() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "sizes?page=0&limit=0&is_active=1",
          params: {
            is_allowed: 1,
          },
        });
        this.sizes = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async fetchAdditions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "additions?page=0&limit=0&is_active=1",
          params: {
            is_allowed: 1,
          },
        });
        this.additions = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.fetchProviders();
    this.fetchCategories();
    this.fetchSizes();
    this.fetchAdditions();
  },
};
</script>
<style>
.add_size_row {
  background-color: transparent;
  color: #266db0 !important;
  border: 1px solid #266db0;
  box-shadow: none !important;
  border-radius: 50% !important;
  min-width: 10px !important;
  padding: 0 12px !important;
}
.remove_size_row {
  background-color: transparent;
  color: rgb(145, 3, 3) !important;
  border: 1px solid rgb(145, 3, 3);
  box-shadow: none !important;
  border-radius: 50% !important;
  min-width: 10px !important;
  padding: 0 12px !important;
}
</style>
